module.exports = __webpack_public_path__ + "static/img/6.ae8528f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6.jpg
// module id = 326
// module chunks = 0